/* ══════════════════════════════════════════════════════════════════════
   SN ECharts theme — mirrors the DS tokens in framework/styles/deck.css.
   ECharts options take literal hex strings (no CSS var support), so the
   token values are duplicated here. Keep in sync with deck.css :root.
   ══════════════════════════════════════════════════════════════════════ */

// DS token hexes used by charts (see deck.css :root)
const BLUE_5 = '#0070D9'; // series 1 (primary)
const TEAL_6 = '#082B3D'; // series 2 (dark)
const BLUE_4 = '#74B0F4'; // series 3 (light)
const GREY_5 = '#697586'; // axis labels
const GREY_3 = '#CDD5DF'; // axis line
const GREY_2 = '#E3E8EF'; // split (grid) lines
const GREY_7 = '#364152'; // legend / title text
const GREY_8 = '#202939'; // gauge value text
const RED_4 = '#E98285'; // coral accent (pie/radar)

export const SN_ECHARTS_THEME = 'sn';

/** Pie/donut slice palette (up to 6 slices) — DS Blue/Teal/Grey + coral. */
export const SN_PIE_PALETTE = [BLUE_5, BLUE_4, TEAL_6, '#9AA4B2', '#CDD5DF', RED_4];

/** Radar series palette — blue / dark slate / coral. */
export const SN_RADAR_PALETTE = [BLUE_5, TEAL_6, RED_4];

/** Gauge ring colors. */
export const SN_GAUGE = {
  progress: BLUE_5,
  track: GREY_2,
  label: GREY_5,
  value: GREY_8,
} as const;

/** Axis/label colors for charts placed on dark (theme:'dark') slides. */
export const SN_CHART_DARK = {
  axisLabel: '#C1CFD7', // teal-2
  splitLine: 'rgba(255,255,255,0.12)',
  axisLine: 'rgba(255,255,255,0.25)',
  legend: '#D8E3EA', // teal-1
} as const;

export const snEchartsTheme = {
  color: [BLUE_5, TEAL_6, BLUE_4],
  backgroundColor: 'transparent',
  textStyle: { fontFamily: 'Funnel Sans, sans-serif', color: GREY_5 },
  title: {
    textStyle: { fontFamily: 'Funnel Display, sans-serif', color: GREY_7, fontWeight: 500 },
  },
  legend: {
    textStyle: { color: GREY_7, fontFamily: 'Funnel Sans, sans-serif' },
    icon: 'circle',
    itemWidth: 10,
    itemHeight: 10,
  },
  categoryAxis: {
    axisLine: { show: true, lineStyle: { color: GREY_3 } },
    axisTick: { show: false },
    axisLabel: { color: GREY_5, fontFamily: 'DM Mono, monospace', fontSize: 11 },
    splitLine: { show: false },
  },
  valueAxis: {
    axisLine: { show: false },
    axisTick: { show: false },
    axisLabel: { color: GREY_5, fontFamily: 'DM Mono, monospace', fontSize: 11 },
    splitLine: { show: true, lineStyle: { color: GREY_2, type: 'solid' } },
    nameTextStyle: { color: GREY_5, fontFamily: 'DM Mono, monospace', fontSize: 11 },
  },
  line: { smooth: true, symbol: 'none', lineStyle: { width: 2 } },
  bar: { itemStyle: { borderRadius: [2, 2, 0, 0] } },
} as const;
